import React, { ReactNode, useEffect, useState } from "react";

/**
 * False while the markup the server sent is being hydrated, true from the next render on.
 *
 * Anything that can only exist in the browser - a widget that measures window.innerWidth,
 * a third party script's mount point - has to be kept out of the browser's first render
 * as well as out of the server's, or React hydrates a tree that does not match what it
 * was given. Asking isBrowser answers a different question: it is already true on that
 * first render, which is precisely the one that has to agree with the server.
 */
export const useAfterHydration = (): boolean => {
    const [hydrated, setHydrated] = useState(false);
    useEffect(() => {
        setHydrated(true);
    }, []);
    return hydrated;
};

/**
 * The same for class components, which cannot call the hook. Children are a function
 * rather than elements, because elements are built by whoever writes them down - on the
 * server too, where reaching for window would throw.
 */
const AfterHydration = ({ children }: { children: () => ReactNode }) =>
    useAfterHydration() ? <>{children()}</> : null;

export default AfterHydration;
